module.exports = __webpack_public_path__ + "static/testimonials-e9d1b9ee80ad3e42d0263dedfc1e75bd.jpg";